module.exports = __webpack_public_path__ + "static/media/Map.4655fe83.gif";